import { render, staticRenderFns } from "./FaceFitTestSubmission.vue?vue&type=template&id=3fab4572&"
import script from "./FaceFitTestSubmission.vue?vue&type=script&lang=js&"
export * from "./FaceFitTestSubmission.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports